"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardEditorContainer_1 = require("../../../../../../shared/components/containers/CardEditorContainer");
var CardRowSelectEditor_1 = require("../../../../../../shared/components/editors/CardRowSelectEditor");
var CmsPageRecordEditor = /** @class */ (function (_super) {
    __extends(CmsPageRecordEditor, _super);
    function CmsPageRecordEditor(props) {
        return _super.call(this, props) || this;
    }
    CmsPageRecordEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            this.setState({
                title: this.props.record.title,
                lang_id: this.props.record.app_language_id,
                lang_title: this.props.record.app_language_title,
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Список страниц", "Список записей", "Редактирование записи"]);
            });
        }
        else {
            this.setState({
                title: "",
                lang_id: -1,
                lang_title: "",
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Список страниц", "Список записей", "Создание записи"]);
            });
        }
        this.doReSetRules();
    };
    CmsPageRecordEditor.prototype.doReSetRules = function () {
        this.setState({
            title_rules: { isError: false },
            lang_rules: { isError: false },
        });
    };
    CmsPageRecordEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                title: this.state.title,
                app_language_id: this.state.lang_id,
                key: this.props.record.key,
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Запись изменена!");
            });
        }
    };
    CmsPageRecordEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.title) || (this.state.title.length === 0)) {
            this.setState({ title_rules: { isError: true, errorMessage: "Поле [название] не заполнено!" } });
            return false;
        }
        if ((this.state.lang_id <= 0) || (this.state.lang_title.length === 0)) {
            this.setState({
                lang_rules: { isError: true, errorMessage: "Поле [язык] не выбрано!" }
            });
            return false;
        }
        return true;
    };
    CmsPageRecordEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                page_data_id: this.props.rootRecord.key,
                title: this.state.title,
                app_language_id: this.state.lang_id,
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Запись добавлена!");
            });
        }
    };
    CmsPageRecordEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    CmsPageRecordEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Добавить запись";
        }
        else {
            return "Изменить запись";
        }
    };
    CmsPageRecordEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 340 },
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Заголовок:", placeholder: "Введите заголовок записи" }, value: this.state.title, onValueChanged: function (newVal) {
                    _this.setState({
                        title: newVal,
                        title_rules: { isError: false }
                    });
                }, required: true, rules: this.state.title_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Язык:", placeholder: "Выберите язык" }, value: { key: this.state.lang_id, value: this.state.lang_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        lang_id: newVal.key,
                        lang_title: newVal.value,
                        lang_rules: { isError: false },
                    });
                }, items: this.props.languagesList, disabled: this.props.record != null, required: true, rules: this.state.lang_rules }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return CmsPageRecordEditor;
}(React.Component));
exports.default = CmsPageRecordEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cms_pages/ui/component/CmsPageRecordEditor.tsx
// module id = 2400
// module chunks = 0